 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTTITLE_PAGE from '@/components/Text/title_page'
 import LOVE_1 from '@/components/love_1'
 import TEXT01_0000312926227_TITLE from '@/components/Text/01_0000312926227_title'
 import TEXT02_0000312926227_COPY from '@/components/Text/02_0000312926227_copy'
 import TEXT05_0000312926227_FM3 from '@/components/Text/05_0000312926227_Fm3'
 import TEXT06_0000312926227_01_CH1 from '@/components/Text/06_0000312926227_01_Ch1'
 import TEXT07_0000312926227_02_CH2 from '@/components/Text/07_0000312926227_02_Ch2'
 import TEXT08_0000312926227_03_CH3 from '@/components/Text/08_0000312926227_03_Ch3'
 import TEXT09_0000312926227_04_CH4 from '@/components/Text/09_0000312926227_04_Ch4'
 import TEXT10_0000312926227_05_CH5 from '@/components/Text/10_0000312926227_05_Ch5'
 import TEXT11_0000312926227_06_CH6 from '@/components/Text/11_0000312926227_06_Ch6'
 import TEXT12_0000312926227_07_CH7 from '@/components/Text/12_0000312926227_07_Ch7'
 import TEXT13_0000312926227_08_CH8 from '@/components/Text/13_0000312926227_08_Ch8'
 import TEXT14_0000312926227_09_CH9 from '@/components/Text/14_0000312926227_09_Ch9'
 import TEXT15_0000312926227_10_CH10 from '@/components/Text/15_0000312926227_10_Ch10'
 import TEXT16_0000312926227_11_CH11 from '@/components/Text/16_0000312926227_11_Ch11'
 import TEXT17_0000312926227_12_CH12 from '@/components/Text/17_0000312926227_12_Ch12'
 import TEXT18_0000312926227_13_CH13 from '@/components/Text/18_0000312926227_13_Ch13'
 import TEXT19_0000312926227_14_CH14 from '@/components/Text/19_0000312926227_14_Ch14'
 import TEXT20_0000312926227_15_CH15 from '@/components/Text/20_0000312926227_15_Ch15'
 import TEXT21_0000312926227_16_CH16 from '@/components/Text/21_0000312926227_16_Ch16'
 import TEXT22_0000312926227_17_CH17 from '@/components/Text/22_0000312926227_17_Ch17'
 import TEXT23_0000312926227_18_CH18 from '@/components/Text/23_0000312926227_18_Ch18'
 import LOVE_2 from '@/components/love_2'
 import TEXT24_0000312926227_19_BACKMA from '@/components/Text/24_0000312926227_19_backma'
 import TEXT25_0000312926227_20_BACKMA1 from '@/components/Text/25_0000312926227_20_backma1'
 import TEXTCHAP212681 from '@/components/Text/chap212681'
 import TEXTCHAP212682 from '@/components/Text/chap212682'
 import TEXTCREDITS from '@/components/Text/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/title_page",
 			"name" : "Text/title_page",
 			"component" : TEXTTITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/01_0000312926227_title",
 			"name" : "Text/01_0000312926227_title",
 			"component" : TEXT01_0000312926227_TITLE
 		},
 		{
 			"path" : "/Text/02_0000312926227_copy",
 			"name" : "Text/02_0000312926227_copy",
 			"component" : TEXT02_0000312926227_COPY
 		},
 		{
 			"path" : "/Text/05_0000312926227_Fm3",
 			"name" : "Text/05_0000312926227_Fm3",
 			"component" : TEXT05_0000312926227_FM3
 		},
 		{
 			"path" : "/Text/06_0000312926227_01_Ch1",
 			"name" : "Text/06_0000312926227_01_Ch1",
 			"component" : TEXT06_0000312926227_01_CH1
 		},
 		{
 			"path" : "/Text/07_0000312926227_02_Ch2",
 			"name" : "Text/07_0000312926227_02_Ch2",
 			"component" : TEXT07_0000312926227_02_CH2
 		},
 		{
 			"path" : "/Text/08_0000312926227_03_Ch3",
 			"name" : "Text/08_0000312926227_03_Ch3",
 			"component" : TEXT08_0000312926227_03_CH3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js